import script from "./OpenGameMiniCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenGameMiniCard.vue?vue&type=script&setup=true&lang=js"

import "./OpenGameMiniCard.vue?vue&type=style&index=0&id=13742c13&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13742c13"]])

export default __exports__